import React from "react";
import configData from "config/config.json";
import { Link } from "react-router-dom";

export const getSplashScreenTableColumns = (params?: any) => {
  return [
    {
      id: "title",
      label: `Title`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "copiedFrom",
      label: `Copied From`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
      renderCell: (row: any) => {
        const id = row?.copiedFrom;
        if (!id || id === "-") return "-";

        const url = configData.routes.splashScreen.edit.replace(":id", id);

        return React.createElement(
          Link,
          {
            to: url,
            target: "_blank",
            onClick: (e: any) => e.stopPropagation(),
            style: {
              color: "#007bff",
              textDecoration: "underline",
              cursor: "pointer",
              opacity: 1,
            },
          },
          id,
        );
      },
    },
    {
      id: "navigationPath",
      label: `Navigation Path`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "body",
      label: `Body`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isTitleBoldText",
      label: `Title Bold`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isBodyBoldText",
      label: `Body Bold`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "order",
      label: `Order`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "targetedUsersCount",
      label: `Targeted Users`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "preview",
      label: `Preview`,
      type: "string",
      isSortable: false,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "actions", label: "Actions" },
  ];
};
